import { Save } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { ENDPOINTS } from "config/constants";
import { useFetch } from "hooks";
import useTranslation from "hooks/useTranslation";
import { useSnackbar } from "notistack";
import { useCallback, useEffect } from "react";
import { CameraModel, IPolygon } from "types";

interface IUploadPolygons {
  cameraId: number | string;
  scale: number;
  polygons: IPolygon[];
  onReload?: (args?: any) => any;
}

export default function UploadPolygons({ scale, cameraId, polygons, onReload }: IUploadPolygons) {
  const {
    isLoading,
    response,
    error,
    callFetch: callFetchGet
  } = useFetch<{
    camera?: CameraModel;
  }>("PUT");
  const { enqueueSnackbar } = useSnackbar();
  const t = useTranslation();
  const onUpload = useCallback(() => {
    // console.log(polygons);
    // return;
    callFetchGet(ENDPOINTS.cameras + "/" + cameraId, {
      body: JSON.stringify({
        polygons: polygons.map((polygon) => ({
          points: polygon.points.map((point) => [point.x / scale, point.y / scale]),
          models: polygon.models
        }))
      })
    })
      .then(onReload)
      .catch(console.error);
  }, [callFetchGet, onReload, cameraId, polygons, scale]);

  useEffect(() => {
    if (response) {
      enqueueSnackbar("Zones updated.");
    }
  }, [enqueueSnackbar, response]);
  useEffect(() => {
    if (error) {
      enqueueSnackbar("Failed to update Zones.");
    }
  }, [enqueueSnackbar, error]);

  return isLoading ? (
    <IconButton>
      <CircularProgress />
    </IconButton>
  ) : (
    <Tooltip title={t["Save Changes"]}>
      <IconButton onClick={onUpload}>
        <Save />
      </IconButton>
    </Tooltip>
  );
}
